import React from "react";
import {FaClock, FaEnvelope, FaHeadset, FaPhoneAlt} from "react-icons/fa";
import ContentPage from "../../components/ContentPage";

const Contact = () => (
	<ContentPage
		icon={<FaHeadset/>}
		eyebrow="WE’RE HERE TO HELP"
		title="Talk to the Barkr team."
		summary="Questions, feedback, account help, or a great dog story—we would love to hear from you."
		asideTitle="Quick contact"
		asideText="Choose the channel that works best for you. We aim to answer business-day messages within 24 hours."
		links={[
			{label: "Email support", href: "mailto:support@barkr.app"},
			{label: "Call support", href: "tel:+359886405340"},
			{label: "Privacy questions", href: "/privacy"},
			{label: "Safety information", href: "/child-safety"},
		]}>
		<div className="content-page__contact-grid">
			<a className="content-page__contact-card" href="mailto:support@barkr.app">
				<span><FaEnvelope/></span>
				<div>
					<strong>Email support</strong>
					<small>support@barkr.app<br/>Best for account, billing, and product questions.</small>
				</div>
			</a>
			<a className="content-page__contact-card" href="tel:+359886405340">
				<span><FaPhoneAlt/></span>
				<div>
					<strong>Call us</strong>
					<small>+359 886 405 340<br/>Available during the support hours below.</small>
				</div>
			</a>
		</div>

		<h2><FaClock/> Support hours</h2>
		<p>Our team is available during the following local hours:</p>
		<div className="content-page__hours">
			<div><span>Monday–Friday</span><strong>9:00–18:00</strong></div>
			<div><span>Saturday</span><strong>10:00–16:00</strong></div>
			<div><span>Sunday</span><strong>Closed</strong></div>
		</div>

		<h2>What to include</h2>
		<p>
			To help us resolve your request quickly, include the phone number or email associated with
			your Barkr account and a short description of what happened. Please never send passwords,
			verification codes, or payment card details.
		</p>

		<div className="content-page__notice">
			<strong>Response times</strong><br/>
			We aim to respond within 24 hours on business days. Messages received on weekends or public
			holidays may take a little longer.
		</div>
	</ContentPage>
);

export default Contact;
